<template>
    <div>
        <div v-if="isLoading">
            <div class="row">
                <div class="col my-4 text-center">
                    <img class="mx-auto" style="height: 25px;" src="/themes/brekz-2017/img/loading-indicator-l.gif">
                    <b class="ml-1 my-auto">{{$t('myAccount.loading')}}</b>
                </div>
            </div>
        </div>
        <div v-else class="row no-gutters">
            <div class="col-12 col-lg-10 offset-0 offset-lg-1">
                <div v-if="!isMobile" class="text--lg my-3">{{ $t("myAccount.titlePersonalInformation") }}</div>
                <div class="account__card account__card--shadow account__card--border-bottom" :class="[showMe || isMobile ? '' : 'pb-5']">
                    <div class="account__border">
                        <div class="account__card--topbar account__card--topbar--padding d-flex align-items-start">
                            <div v-show="showMe" class="text--green">{{ $t("myAccount.adjustData") }}</div>
                            <i v-show="!showMe" class="fas fa-3x fa-address-book text--gray-mid mr-3"></i>
                            <div v-show="!showMe">
                                <div class="mb-2"><strong>{{ account.account.first_name }}&nbsp;{{ account.account.last_name }}</strong></div>
                                <div class="mb-2"><strong>{{ account.account.email }}</strong></div>
                                <div><i class="fas fa-lock text--gray-mid mr-2"></i>***********</div>
                            </div>
                            <button class="text-center button-brekz button-brekz--rounded button-brekz--yellow button--icon-left text--gray-600 ml-auto"
                                    v-show="!showMe"
                                    @click="openAccountCollapse()">
                                <i class="fas fa-pencil-alt mr-2"></i>
                                <span class="d-none d-md-inline-block">{{ $t("myAccount.adjust") }}</span>
                            </button>
                        </div>
                    </div>
                    <div id="collapse_account" class="collapse" aria-expanded="false">
                        <div class="account__border py-4">
                            <div class="account--padding">
                                <div class="row">
                                    <div class="col-6 mb-2">
                                        <div>{{ $t("myAccount.firstName") }}</div>
                                        <span :class="{'input--after': checkInput('first_name') }">
                                            <input v-model="account.account.first_name" name="first_name" class="input" :class="{'input--error': checkInput('first_name') }" v-on:change="checkForm()" type="text" placeholder="Jan">
                                        </span>
                                    </div>
                                    <div class="col-6 mb-2">
                                        <div>{{ $t("myAccount.lastName") }}</div>
                                        <span :class="{'input--after': checkInput('last_name') }">
                                            <input v-model="account.account.last_name" name="first_name" class="input" :class="{'input--error': checkInput('last_name') }" v-on:change="checkForm()" type="text" placeholder="Janssen">
                                        </span>
                                    </div>
                                    <div class="col-12 mb-4">
                                        <div>{{ $t("myAccount.email") }}</div>
                                        <span :class="{'input--after': checkInput('email') }">
                                            <input v-model="account.account.email" name="first_name" class="input" :class="{'input--error': checkInput('email') }" v-on:change="checkForm()" type="email" placeholder="E-mail">
                                        </span>
                                    </div>
                                    <div class="col-12 mb-2">
                                        <strong>({{ $t("myAccount.optional") }})</strong>
                                    </div>
                                    <div class="col-12 mb-2">
                                        <div class="mb-2" style="position: relative;">
                                            <div>{{ $t("myAccount.currentPassword") }}</div>
                                            <input id="current_password" class="input" :class="{'input--error': checkInput('current_password')}" v-model="account.account.current_password" type="password" placeholder="******">
                                            <i id="current_password_show" @click="toggleVisibility($event)" class="fas fa-eye input--icon cursor-pointer" :class="{ 'text--green' : eyeCurrentPassword }"></i>
                                        </div>
                                        <div style="position: relative;">
                                            <div>{{ $t("myAccount.newPassword") }}</div>
                                            <input id="password" class="input" :class="{'input--error': checkInput('password')}"  v-model="account.account.password" type="password" placeholder="******">
                                            <i id="password_show" @click="toggleVisibility($event)" class="fas fa-eye input--icon cursor-pointer" :class="{ 'text--green' : eyePassword }"></i>
                                        </div>
                                    </div>

                                    <div v-if="errorBag.length > 0" class="col-12 mt-3 text--sm">
                                        <i class="fas fa-times-circle text-danger mr-2"></i><span class="text-danger font-weight-bold">{{ $t("myAccount.errorMessage") }}</span>
                                        <div v-for="error in errorBag">
                                            <div class="text-danger ml-4" v-text="'- ' + error.errorMessage"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="account__card--bottom-bar align-items-center" :class="[isMobile ? 'py-3' : 'pt-4']">
                            <button href="#"
                                    title="cancel Edit"
                                    @click="cancelEdit()"
                                    class="button button--clear m-0">{{ $t("myAccount.cancel") }}</button>
                            <button class="button-brekz button-brekz--rounded button-brekz--xl m-0"
                                    :class="{'button-brekz--green': !isSubmitting}"
                                    @click="submitForm(account.account)">
                                <img v-if="isSubmitting"
                                     class="mx-auto"
                                     style="height: 25px;"
                                     src="/themes/brekz-2017/img/loading-indicator-l.gif">
                                <div v-else >{{ $t("myAccount.save") }}</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-10 offset-0 offset-lg-1">
                <div v-show="!isMobile" class="mt-4 text--lg">{{ $t('myAccount.addresses') }}</div>
                <Address v-bind:isMobile="isMobile" :default-country-id="defaultCountryId" :get-address-link="getAddressLink"></Address>
            </div>
        </div>
        <modal-vue :title="$t('myAccount.passwordIncorrect')"
                   :show="showErrorModal"
                   @close="showErrorModal = false"
                   width="xs"
                   :buttons='[{text: $i18n.t("myAccount.close"), class: "button-brekz button-brekz--rounded button-brekz--green button--extra-large mx-auto", emit_name: "close"}]'>
            <p class="my-3 mx-3" v-text="errorText"></p>
        </modal-vue>

        <modal-vue :title="$t('myAccount.titlePersonalInformation')"
                   :show="showSaveConfirmationModal"
                   @close="showSaveConfirmationModal = false"
                   :buttons='[{text: $i18n.t("myAccount.okay"), class: "button-brekz button-brekz--rounded button-brekz--yellow button--extra-large", emit_name: "close"}]'>
            <p class="my-3 mx-3">{{ $t("myAccount.saveConfirmationModalTitle") }}</p>
        </modal-vue>

    </div>
</template>

<script>
    import Address from "./Address";
    import ModalVue from "./ModalVue.vue";

    export default {
        name: "Account",
        components: { Address, ModalVue },
        props: {
            isMobile: Boolean,
            defaultCountryId: Number,
            getAccountLink: String,
            updateAccountLink: String,
            getAddressLink: String,
        },
        data() {
            return {
                count: 0,
                isLoading: true,
                showMe: false,
                account: [],
                errorBag: [],
                isSubmitting: false,
                errorText: '',
                showErrorModal: false,
                showSaveConfirmationModal: false,
                eyeCurrentPassword: false,
                eyePassword: false,

            }
        },
        methods: {
            getAccountDetails() {
                this.isLoading = true;

                jQuery.ajax(this.getAccountLink, {
                    type: "GET",
                    success: response => {
                        this.account = response;
                        this.isLoading = false;
                    },
                    error: XMLHttpRequest => {
                        this.showErrorModal = true;
                    }
                });
            },
            validateEmail(email) {
                var re = /^[a-z\u00DF\u00E0-\u00FF0-9+\/=?^`{}|~_-]+[.a-z0-9+\/=?^`{}|~_-]*@[a-z0-9]+[._a-z\p{L}0-9-]*\.[a-z0-9]+$/i;
                return re.test(email);
            },
            validatePassword(password) {
                var re = /^(.{6,30})$/i;
                return re.test(password);
            },
            checkForm() {
                let success = true;
                this.errorBag = [];
                if (!this.account.account.first_name || this.account.account.first_name.length <= 2){
                    this.errorBag.push({
                        "fieldName": "first_name",
                        "errorMessage" : this.$t('myAccount.errorFirstName')
                    });

                    success = false;
                }

                if (!this.account.account.last_name || this.account.account.last_name.length <= 2) {
                    this.errorBag.push({
                        "fieldName": "last_name",
                      "errorMessage" : this.$t('myAccount.errorLastName')
                    });

                    success = false;
                }
                if (!this.account.account.email || !this.validateEmail(this.account.account.email)){
                    this.errorBag.push({
                        "fieldName": "email",
                      "errorMessage" : this.$t('myAccount.errorEmail')
                    });

                    success = false;
                }
                return success;
            },
            checkInput(inputName) {
                for (let i = 0; i < this.errorBag.length; i++) {
                    if (this.errorBag[i].fieldName === inputName) {
                        return true;
                    }
                }

                return false;
            },
            submitForm(data) {
                if (!this.checkForm()) {
                    return;
                }

                this.isSubmitting = true;
                if ($('#current_password')[0].value === '') {
                    delete data.current_password;
                }

                jQuery.ajax(this.updateAccountLink, {
                    type: "UPDATE",
                    data: JSON.stringify(data),
                    success: response => {

                        this.isSubmitting = false;
                        this.showSaveConfirmationModal = true;
                        this.account.account.current_password = '';
                        this.account.account.password = '';
                        this.closeAccountCollapse();

                    },
                    error: XMLHttpRequest => {
                        this.errorText = JSON.parse(XMLHttpRequest.responseText).error;

                        if (XMLHttpRequest.status === 422) {
                            this.showErrorModal = true;
                            this.errorBag.push({
                                "fieldName": "current_password",
                                "errorMessage": this.errorText
                            });
                        }
                        this.isSubmitting = false;
                    }
                });
            },
            openAccountCollapse(){
                this.showMe = !this.showMe;
                $('#collapse_account').collapse('show');
            },

            closeAccountCollapse(){
                this.showMe = !this.showMe;
                $('#collapse_account').collapse('hide');
            },
            cancelEdit() {
                this.closeAccountCollapse();
            },
            toggleVisibility(event) {
                let targetId = event.target.id;
                if (targetId === 'current_password_show' && $('#current_password')[0].type === "password"){
                    $('#current_password')[0].type = "text"
                    this.eyeCurrentPassword = true;
                }
                else if(targetId === 'current_password_show') {
                    $('#current_password')[0].type = "password"
                    this.eyeCurrentPassword = false;
                }
                if (targetId === 'password_show' && $('#password')[0].type === "password"){
                    $('#password')[0].type = "text"
                    this.eyePassword = true;
                }
                else if(targetId === 'password_show') {
                    $('#password')[0].type = "password"
                    this.eyePassword = false;
                }

            }
        },
        mounted() {
            this.getAccountDetails();
        }
    }
</script>
